import * as React from "react";
import { Component } from "react";
import { Button, Glyphicon, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { IBaseState } from "src/interfaces";
import { INavbarProps } from "./interfaces";

export default class SignedOutLinks extends Component<INavbarProps, IBaseState> {
  public constructor(props: INavbarProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    return (
      <Nav pullRight={true}>
        <NavLink to="/login">
          <Button bsStyle="primary" bsSize="small" className="button-top-margin-times-two">
            <Glyphicon glyph="glyphicon glyphicon-log-in" />
          </Button>
        </NavLink>
      </Nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/SignedOutLinks.tsx